import { Box, Chip, Divider, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { nanoid } from '@reduxjs/toolkit';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import {
	VAT_CORRECTIONS_SCHEME_NAMES,
	VatCorrectionsScheme,
	VatCorrectionsStatus,
} from 'redux/reducers/vatCorrections/constants';
import { TOrderVatCorrectionsItemProps } from './types';
import { EasChip } from 'ui/EasChip';
import { COLORS } from 'services/constants/colors';

export const OrderVatCorrectionsItem: FC<TOrderVatCorrectionsItemProps> = ({
	varCorrectionsItem,
}) => {
	return (
		<Box>
			<Box
				sx={{
					border: '1px solid #00000020',
					borderRadius: '12px',
					padding: '10px',
					marginBottom: '10px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'start',
						alignItems: 'center',
						gap: 1,
						mb: 2,
					}}
				>
					<Typography variant="body2" color="text.secondary">
						Created at:{' '}
						{varCorrectionsItem?.timestamp &&
							DateTime.fromISO(varCorrectionsItem?.timestamp).toFormat('yyyy-MM-dd, HH:mm')}
					</Typography>
					<EasChip
						label={varCorrectionsItem?.approvalStatus?.replaceAll('_', ' ').toLowerCase()}
						bgcolor={
							varCorrectionsItem?.approvalStatus === VatCorrectionsStatus.APPROVED
								? COLORS.SUCCESS
								: varCorrectionsItem?.approvalStatus === VatCorrectionsStatus.PENDING
									? COLORS.WARNING
									: varCorrectionsItem?.approvalStatus === VatCorrectionsStatus.REJECTED
										? COLORS.ERROR
										: COLORS.SECONDARY
						}
					/>
					{varCorrectionsItem?.approvedRejectedOn && (
						<Typography variant="body2" color="text.secondary">
							Approval date:{' '}
							{DateTime.fromISO(varCorrectionsItem?.approvedRejectedOn).toFormat(
								'yyyy-MM-dd, HH:mm',
							)}
						</Typography>
					)}
				</Box>

				<Box sx={{ ml: 0 }} key={nanoid()}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							gap: 2,
						}}
					>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								gap: 1,
							}}
						>
							{' '}
							<Typography
								variant="body2"
								sx={{
									fontWeight: 'bold',
								}}
								color="primary"
							>
								{VAT_CORRECTIONS_SCHEME_NAMES?.[
									varCorrectionsItem.scheme as keyof typeof VatCorrectionsScheme
								] ?? varCorrectionsItem.scheme}
							</Typography>
							<Typography variant="body2">
								Reporting period:{' '}
								{/* <span style={{ fontWeight: 'bold' }}>
									{varCorrectionsItem.reportingMonthQuarter} {varCorrectionsItem.reportingYear}
								</span> */}
							</Typography>
							{varCorrectionsItem?.reportingYear ? (
								<EasChip
									label={`${varCorrectionsItem?.reportingYear}-${varCorrectionsItem.scheme === VatCorrectionsScheme.UNION || varCorrectionsItem.scheme === VatCorrectionsScheme.NON_UNION ? 'Q' : 'M'}${varCorrectionsItem.reportingMonthQuarter}`}
									bgcolor={
										varCorrectionsItem.scheme === VatCorrectionsScheme.UNION ||
										varCorrectionsItem.scheme === VatCorrectionsScheme.NON_UNION
											? '#7f00e72b'
											: COLORS.SECONDARY
									}
								/>
							) : (
								<Typography
									variant="body2"
									sx={{
										fontWeight: 'bold',
									}}
									color="primary"
								>
									N/A
								</Typography>
							)}
							{/* <Chip
								label={`-${child.discountPercentage.toFixed(1)} %`}
								size="small"
								sx={{
									p: '0 2px',
									fontSize: '.7rem',
									height: '18px',
									bgcolor: '#ffeb78',
									// color: '#fff',
								}}
							/> */}
						</Box>

						<AmountAndCurrency
							amount={varCorrectionsItem.requestedValueCorrection}
							currency={varCorrectionsItem.currencyName ?? 'EUR'}
							bold
							size={1}
							color={COLORS.PRIMARY}
						/>
					</Box>
					{/* {detalization && (
						<>
							<AmountWithQuantity
								name="Item VAT"
								amount={child.discountOnVat}
								quantity={child.quantity}
								paymentCurrency={paymentCurrency ?? ''}
							/>

							<Divider sx={{ mt: 0.4, mb: 0.4, ml: 4 }} />
							<AmountWithQuantity
								name=" "
								amount={+child.discountOnCost + +child.discountOnVat}
								quantity={child.quantity}
								paymentCurrency={paymentCurrency ?? ''}
								total
							/>
						</>
					)} */}
					<Box>
						<Typography variant="body2" color="text.secondary">
							{varCorrectionsItem.actionRemarks}
						</Typography>
					</Box>
				</Box>
				{/* {(discountOrderBreakdown?.length ?? 0) > 1 && (
					<>
						<Divider sx={{ mt: 1, mb: 1, ml: 4 }} />
						<Box sx={{ display: 'flex', justifyContent: 'end' }}>
							<AmountAndCurrency
								amount={orderDiscountsItem?.total_discount_amount}
								currency={paymentCurrency ?? 'EUR'}
								bold
								size={1}
							/>
						</Box>
					</>
				)} */}
			</Box>
		</Box>
	);
};
